import { cn } from '@endure/ui';
import { Slot } from '@radix-ui/react-slot';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  asChild?: boolean;
}

export const Card: React.FC<CardProps> = ({ className, asChild = false, ...otherProps }) => {
  const Comp = asChild ? Slot : 'div';

  return (
    <Comp
      className={cn(
        // Flat, tone-on-tone surfaces: generous radius, no visible border — the
        // transparent border keeps layout stable for variants that colour it.
        'block w-full rounded-3xl border border-transparent bg-cards p-4',
        className,
      )}
      {...otherProps}
    />
  );
};
